// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PainelRouteImport } from './routes/painel'
import { Route as ObrigadoRouteImport } from './routes/obrigado'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RTokenRouteImport } from './routes/r.$token'
import { Route as PreviewSlugRouteImport } from './routes/preview.$slug'
import { Route as PainelMatrizIdEditarRouteImport } from './routes/painel.matriz.$id.editar'

const PainelRoute = PainelRouteImport.update({
            id: '/painel',path: '/painel',getParentRoute: () => rootRouteImport
          })
const ObrigadoRoute = ObrigadoRouteImport.update({
            id: '/obrigado',path: '/obrigado',getParentRoute: () => rootRouteImport
          })
const SlugRoute = SlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const RTokenRoute = RTokenRouteImport.update({
            id: '/r/$token',path: '/r/$token',getParentRoute: () => rootRouteImport
          })
const PreviewSlugRoute = PreviewSlugRouteImport.update({
            id: '/preview/$slug',path: '/preview/$slug',getParentRoute: () => rootRouteImport
          })
const PainelMatrizIdEditarRoute = PainelMatrizIdEditarRouteImport.update({
            id: '/matriz/$id/editar',path: '/matriz/$id/editar',getParentRoute: () => PainelRoute
          })





const PainelRouteChildren = {
  PainelMatrizIdEditarRoute: PainelMatrizIdEditarRoute
}

const PainelRouteWithChildren = PainelRoute._addFileChildren(PainelRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SlugRoute: SlugRoute,ObrigadoRoute: ObrigadoRoute,PainelRoute: PainelRouteWithChildren,PreviewSlugRoute: PreviewSlugRoute,RTokenRoute: RTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)